var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress } from '../../../../Fct/generics';
import { swapExactTokensForTokensParams } from '../../../../Fct/plugins/uniswap/actions/params';
import { ROUTER_ADDRESSES } from '../constants';
export var SwapExactTokensForTokens = createPlugin({
    protocol: 'SUSHISWAP',
    type: 'ACTION',
    method: 'swapExactTokensForTokens',
    getParams: function () { return (__assign(__assign({}, swapExactTokensForTokensParams), { to: new FctAddress({ destination: 'sushiswap_router' }) })); },
    supportedContracts: ROUTER_ADDRESSES,
    initParams: {
        methodParams: {
            deadline: { type: 'global', id: 'blockTimestamp' },
        },
    },
    requiredApprovals: function (params) {
        var token = (params === null || params === void 0 ? void 0 : params.methodParams.path.value) && Array.isArray(params === null || params === void 0 ? void 0 : params.methodParams.path.value)
            ? params === null || params === void 0 ? void 0 : params.methodParams.path.value[0]
            : undefined;
        return [
            {
                to: token,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.methodParams.amountIn.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
